import { CourseKindSchema } from '@duke-hq/svc-api-db/schemas/enums/CourseKind.schema';
import { QualificationKindSchema } from '@duke-hq/svc-api-db/schemas/enums/QualificationKind.schema';

export const CourseKindLabels: Record<string, string> = {
  [CourseKindSchema.enum.SKILL_SET]: 'Skill set',
  [CourseKindSchema.enum.QUALIFICATION]: 'Qualification',
  [CourseKindSchema.enum.NON_VOCATIONAL]: 'Non-vocational',
  [CourseKindSchema.enum.SHORT_COURSE]: 'Short course',
};

export const CourseKindOptions = Object.entries(CourseKindLabels).map(([value, label]) => ({
  value,
  label,
}));

const { QUALIFICATION, SKILL_SET, NON_VOCATIONAL } = CourseKindSchema.enum;
const { CERT_II, CERT_III, CERT_IV } = QualificationKindSchema.enum;

// Maps a course to its display section for `SectionedList`. Compares against the Zod
// enum identifiers (the values returned at runtime), not the prisma-client enum
// constants, which resolve to the @map'd DB values and never match.
export const courseSection = (course: {
  kind: string;
  qualificationKind: string | null;
}): { key: string; label: string } => {
  if (course.kind === QUALIFICATION) {
    if (course.qualificationKind === CERT_IV) {
      return { key: CERT_IV, label: 'Certificate IV' };
    }
    if (course.qualificationKind === CERT_III) {
      return { key: CERT_III, label: 'Certificate III' };
    }
    if (course.qualificationKind === CERT_II) {
      return { key: CERT_II, label: 'Certificate II' };
    }
  }
  if (course.kind === SKILL_SET) {
    return { key: SKILL_SET, label: 'Skill sets' };
  }
  if (course.kind === NON_VOCATIONAL) {
    return { key: NON_VOCATIONAL, label: 'Non-vocational' };
  }
  return { key: 'OTHER', label: 'Other' };
};
